import {mobileImage} from "../mobileAssets";

function renderContentBlock(block, index) {
    if (!block) return null;
    if (typeof block === "string") return <p key={index}>{block}</p>;
    if (block.type === "heading") return <h3 key={index}>{block.text}</h3>;
    if (block.type === "subheading") return <h4 key={index}>{block.text}</h4>;
    return <p key={index}>{block.text}</p>;
}

function formatNewsDate(value) {
    const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[1]}.${match[2]}.${match[3]}` : value;
}

export default function ArticleScreen({article, isLoading, onBack}) {
    const remoteContent = article && Array.isArray(article.content) ? article.content : null;
    return (
        <div className="page_article">
            <div className="title"><span>最新</span><p>公平运营声明</p></div>
            <div className={remoteContent ? "article has-remote" : "article"}>
                {isLoading ? <p className="mobile-article-loading">Loading...</p> : null}
                {!isLoading && remoteContent ? <div className="mobile-article-remote"><h2>{article.title}</h2>{remoteContent.map(renderContentBlock)}{article.datetime ? <p>{formatNewsDate(article.datetime)}</p> : null}</div> : null}
                <p>感谢您对《失乐枷锁》的关注与支持。为维护绿色、公平的游戏环境，保障各位玩家的合法权益，我们将采取以下举措：</p>
                <strong>1. 标题示范（只增加字重）</strong>
                <p>1. 禁止游戏中使用外挂、插件等第三方工具以及其他破坏游戏公平性的行为。不得以任何不正当方式破坏游戏公平性、违反游戏用户协议。</p>
                <p>2. 禁止任何形式的转让、共享、交易游戏账号行为。为了保护您的个人信息与财产安全，请勿进行非官方账号交易行为。</p>
                <p>3. 禁止一切非正规途径充值行为。游戏严禁利用平台规则漏洞进行非法充值。</p>
            </div>
            <div className="back"><button type="button" onClick={onBack}><img src={mobileImage("ones_10.png")} alt="返回新闻列表"/></button></div>
        </div>
    );
}
